import * as angular from "angular";
import * as Ps from 'perfect-scrollbar';
class SidebarController implements ng.IComponentController {

    private psTarg: any;
    private menuitems: any;
    private logo: any;

    constructor(private $scope: any, private $window: any, private ThemeService: aboTheme.IThemeService) {
        'ngInject';

        this.psTarg = angular.element('.sidebar-panel > nav');

        $scope.winWidth = () => {
            return window.innerWidth;
        };

        $scope.$watch($scope.winWidth, (newValue, oldValue) => {

            if ($scope.mobileView >= newValue || angular.element('.app').hasClass('layout-small-menu')) {
                if (this.psTarg.hasClass('ps-container')) {
                    this.destroyScrollbars();
                }
                return;
            }
            else {
                if (!this.psTarg.hasClass('ps-container')) {
                    this.initScrollbars();
                }
                return;
            }
        }, true);

        window.onresize = () => {
            $scope.$apply();
        };
    }

    public $onInit = () => {
        this.logo = this.ThemeService.getLogo();
    }

    private menuClick = ($event) => {

        var $this = $($event.target),
            links = $this.parents('li'),
            parentLink = $this.closest('li'),
            otherLinks = angular.element('.sidebar-panel nav li').not(links),
            subMenu = $this.next();

        if (angular.element('.app').hasClass('layout-small-menu') && parentLink.parent().hasClass('nav') && this.$window.width() > 768) {
             return;
        }

        otherLinks.removeClass('open');

        if (subMenu.is('ul') && (subMenu.height() === 0)) {
            parentLink.addClass('open');
        } else if (subMenu.is('ul') && (subMenu.height() !== 0)) {
            parentLink.removeClass('open');
        }

        this.updateScrollbars();

        if (subMenu.is('ul')) {
            return false;
        }

        $event.stopPropagation();

        return true;
    }

    private toggleSidebar = () => {
        angular.element('.app').toggleClass('layout-small-menu');
    }

    private initScrollbars = function () {
        var nav = angular.element('.sidebar-panel > nav').get(0);
        // angular.element('.sidebar-panel > nav').perfectScrollbar({
        //     wheelPropagation: true,
        //     suppressScrollX: true
        // });
        Ps.initialize(nav, {
            wheelPropagation: true,
            suppressScrollX: true
        })
    };

    private destroyScrollbars = function () {
        if (this.psTarg.hasClass('ps-container')) {
            Ps.destroy(this.psTarg.get(0));
            this.psTarg.removeClass('ps-active-y');
        }
    };

    private updateScrollbars = function () {
        if (this.psTarg.hasClass('ps-container') && !angular.element('.app').hasClass('layout-small-menu')) {
            //this.psTarg.perfectScrollbar('update');
            Ps.update(this.psTarg.get(0));
        }
    };

};

export const sidebar = {
    controller: SidebarController,
    bindings: {
        menuitems: '=',
        version: '='
    },
    template: require('./sidebar.html')
};



// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/main/sidebar.component.ts